import { connect } from 'react-redux'
import * as actions from './FlashMessageActions'
import FlashMessage from './FlashMessage'

const mapStateToProps = (state) => ({ 
    flashMessage: state.flashMessage.flashMessage
})

export default connect(mapStateToProps, actions)(FlashMessage)


// WEBPACK FOOTER //
// ./src/components/FlashMessage/index.jsx